import { connect } from 'react-redux';
import CustomerDetail from "../Component/CustomerDetail";
import {
  getCustomers,
  getCommercialCustomer,
  updateCommercialCustomer,
  getAccountInfo,
  getServiceOrder,
  updateNotificationById,
  updateCard,
  deleteCard,
  addNewCard,
  getBlockList,
  getAccountNotes,
  addAccountNotes,
  getCardList,
  getNotificationById,
  getAuthorizedUserList,
  addAuthorizedUser,
  deleteAuthorizedUser,
  getCallLogList,
  addCallLog,
  getPricingHistory,
  viewService,
  getPauseService,
  pauseService,
  updatePauseService,
  getPauseReason,
  deletePauseService,
  editService,
  getPets,
  addPet,
  updatePet,
  deletePet,
  getFranchiseById,
  getCSVData,
  sendEmailReminder,
  getServiceOrderById,
  getInvoiceList,
  getInvoiceCreditMemoList,
  getInvoiceById,
  getInvoiceSummary,
  resendInvoice,
  printInvoices,
  addInvoice,
  deleteInvoice,
  editInvoice,
  getServiceOrderNumberList,
  addPaymentLog,
  addManualPaymentLog,
  deletePaymentLog,
  addInvoiceLineItem,
  editInvoiceLineItem,
  deleteInvoiceLineItem,
  getAllMessages,
  getUserList,
  getGroupList,
  createNewTickets,
  MessageReplies,
  UpdateTickets,
  readTickets,
  getMessagesCount,
  addGuestUser,
  updateGuestUser,
  deleteGuestUser,
  addBlockUser,
  deleteBlockUser,
  requestRepairService,
  getServiceAgreement,
  addServiceAgreement,
  deleteServiceAgreement,
  addCommercialProposal,
  addInnerCommercialProposal,
  updateInnerCommercialProposal,
  getCommercialProposal,
  getCommercialProposalById,
  patchCommercialProposal,
  sendProposalMail,
  getProposalPdf,
  getAllQuote,
  getQuoteById,
  updateServiceLineItem,
  exportPDFStatement,
  getAccountListing,
  getPaymentHistory,
  finalizeInvoice,
  getStaffUsers,
  getInvoiceDescription,
  getWorkOrderTypeDescription,
  deleteProposalLineItems,
  getFieldTechnicianList,
  getBDA,
  getServiceHistory,
  refundPayment,
  getSalesTax,
  suspendAccount,
  getCustomerDetail,
  deleteInnerProposal,
  getGeocodeAddress,
  resetGeocodeAddress,
  getRepresentativeList,
  updateCallLog,
  getCommercialWorkOrderList,
  getCommercialWorkOrder,
  getFieldTechnicianFilter,
  getWorkOrderFilter,
  getServiceOrderFilter,
  editFieldOffice,
  voidInvoice,
  addManualInvoice,
  getBillingAddress,
  postPaymentLog,
  addCreditMemo,
  addCreditMemoLineItem,
  getCreditMemoDetails,
  lastThreeCreditMemo,
  addUnattachedPayment,
  cleanPaymentResponse,
  getLastThreePayment,
  deleteAccountInvoice,
  invoiceProcess,
  getServiceOrders,
  getDiscounts,
  calculatePriceForPrepay,
  createPrepay,
  remainingCreditBalance,
  cleanPrePaymentResponse,
  getReasonList
} from '../../../../Action';

const mapStateToProps = (state) => {
  const {
    CustomerList,
    CommercialProposal,
    CommercialCustomer,
    ServiceOrder,
    UpdateNotification,
    UpdateCard,
    DeleteCard,
    AddCard,
    BlockList,
    AccountNotes,
    CardList,
    NotificationList,
    AuthorizedUser,
    CallLog,
    PricingHistory,
    Service,
    Pet,
    EmailReminder,
    Invoice,
    InvoiceCreditMemoList,
    AllMessages,
    UserList,
    GroupList,
    NewTicket,
    RepliesonTicket,
    UpdateMesssage,
    MessageCount,
    PDFExportStatement,
    GetAccountList,
    PaymentHistory,
    GetManualy,
    InvoiceDescription,
    WorkOrderTypeDescription,
    FieldTechnician,
    GoogleApi,
    RepresentativeList,
    CommercialWorkOrderList,
    CommercialWorkOrder,
    fieldTechnicianFilter,
    WorkOrderFilter,
    WorkOrderList,
    WorkOrderDetail,
    ServiceOrderFilter,
    EditFieldOffice,
    VoidInvoice,
    PostPaymentLog,
    DeletePaymentLog,
    AddPaymentLog,
    BillingAddress,
    LastThreePayment,
    DeleteInvoice,
    InvoiceProcess,
    ServiceOrders,
    Discounts,
    RemainingCreditBalance,
    getReasons
  } = state;

  return {
    CustomerList,
    CommercialProposal,
    CommercialCustomer,
    ServiceOrder,
    UpdateNotification,
    UpdateCard,
    DeleteCard,
    AddCard,
    BlockList,
    AccountNotes,
    CardList,
    NotificationList,
    AuthorizedUser,
    CallLog,
    PricingHistory,
    Service,
    Pet,
    EmailReminder,
    Invoice,
    AllMessages,
    UserList,
    GroupList,
    NewTicket,
    RepliesonTicket,
    UpdateMesssage,
    MessageCount,
    PDFExportStatement,
    GetAccountList,
    PaymentHistory,
    GetManualy,
    InvoiceDescription,
    FieldTechnician,
    GoogleApi,
    RepresentativeList,
    CommercialWorkOrderList,
    CommercialWorkOrder,
    fieldTechnicianFilter,
    WorkOrderFilter,
    ServiceOrderFilter,
    EditFieldOffice,
    VoidInvoice,
    PostPaymentLog,
    DeletePaymentLog,
    BillingAddress,
    InvoiceCreditMemoList,
    WorkOrderTypeDescription,
    WorkOrderList,
    WorkOrderDetail,
    AddPaymentLog,
    LastThreePayment,
    DeleteInvoice,
    InvoiceProcess,
    ServiceOrders,
    Discounts,
    RemainingCreditBalance,
    getReasons
  }
}

const actionCreators = {
  getCustomers,
  getCommercialCustomer,
  updateCommercialCustomer,
  addGuestUser,
  updateGuestUser,
  deleteGuestUser,
  getAccountInfo,
  getServiceOrder,
  updateServiceLineItem,
  updateNotificationById,
  updateCard,
  deleteCard,
  addNewCard,
  getBlockList,
  getAccountNotes,
  addAccountNotes,
  getCardList,
  getNotificationById,
  getAuthorizedUserList,
  addAuthorizedUser,
  deleteAuthorizedUser,
  getCallLogList,
  addCallLog,
  getPricingHistory,
  viewService,
  getPauseService,
  pauseService,
  updatePauseService,
  getPauseReason,
  deletePauseService,
  editService,
  getPets,
  addPet,
  updatePet,
  deletePet,
  sendEmailReminder,
  getFranchiseById,
  getServiceOrderById,
  getServiceHistory,
  getInvoiceList, // invoice
  getInvoiceCreditMemoList,
  finalizeInvoice,
  getInvoiceById,
  getServiceOrderNumberList,
  getInvoiceSummary,
  resendInvoice,
  printInvoices,
  addInvoice,
  editInvoice,
  deleteInvoice,
  addPaymentLog,
  addManualPaymentLog,
  deletePaymentLog,
  addInvoiceLineItem,
  editInvoiceLineItem,
  deleteInvoiceLineItem,
  refundPayment,
  getSalesTax,
  getStaffUsers,
  getAllMessages,
  getUserList,
  getCSVData,
  getGroupList,
  createNewTickets,
  MessageReplies,
  UpdateTickets,
  readTickets,
  getMessagesCount,
  addBlockUser,
  deleteBlockUser,
  requestRepairService,
  getServiceAgreement,
  addServiceAgreement,
  deleteServiceAgreement,
  addCommercialProposal, // apis for proposal
  addInnerCommercialProposal,
  updateInnerCommercialProposal,
  getCommercialProposal,
  getCommercialProposalById,
  patchCommercialProposal,
  sendProposalMail,
  getProposalPdf,
  getAllQuote,
  getQuoteById,
  deleteProposalLineItems,
  deleteInnerProposal,
  getBDA, // end of proposal api
  exportPDFStatement,
  getAccountListing,
  getPaymentHistory,
  getInvoiceDescription,
  getFieldTechnicianList,
  suspendAccount,
  getCustomerDetail,
  getGeocodeAddress,
  resetGeocodeAddress,
  getRepresentativeList,
  updateCallLog,
  getCommercialWorkOrderList,
  getCommercialWorkOrder,
  getFieldTechnicianFilter,
  getWorkOrderFilter,
  getServiceOrderFilter,
  editFieldOffice,
  voidInvoice,
  postPaymentLog,
  addManualInvoice,
  getBillingAddress,
  addCreditMemo,
  addCreditMemoLineItem,
  getCreditMemoDetails,
  lastThreeCreditMemo,
  addUnattachedPayment,
  cleanPaymentResponse,
  cleanPrePaymentResponse,
  getWorkOrderTypeDescription,
  getLastThreePayment,
  deleteAccountInvoice,
  invoiceProcess,
  getServiceOrders,
  getDiscounts,
  calculatePriceForPrepay,
  createPrepay,
  remainingCreditBalance,
  getReasonList
}
export default (connect(mapStateToProps, actionCreators)(CustomerDetail));